"use strict";

var _slicedToArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamPartIDUtils = exports.toStreamPartID = void 0;

var StreamID_1 = require("./StreamID");

var DELIMITER = '#';
var MAX_PARTITION_COUNT = 100;

function ensureValidStreamPartition(streamPartition) {
  if (!Number.isSafeInteger(streamPartition) || streamPartition < 0 || streamPartition >= MAX_PARTITION_COUNT) {
    throw new Error("invalid streamPartition value: ".concat(streamPartition));
  }
}

function toStreamPartID(streamId, streamPartition) {
  ensureValidStreamPartition(streamPartition);
  return "".concat(streamId).concat(DELIMITER).concat(streamPartition);
}

exports.toStreamPartID = toStreamPartID;

var StreamPartIDUtils = /*#__PURE__*/function () {
  function StreamPartIDUtils() {
    _classCallCheck(this, StreamPartIDUtils);
  }

  _createClass(StreamPartIDUtils, null, [{
    key: "parse",
    value: function parse(streamPartIdAsStr) {
      var _StreamPartIDUtils$pa = StreamPartIDUtils.parseRawElements(streamPartIdAsStr),
          _StreamPartIDUtils$pa2 = _slicedToArray(_StreamPartIDUtils$pa, 2),
          streamId = _StreamPartIDUtils$pa2[0],
          streamPartition = _StreamPartIDUtils$pa2[1];

      if (streamPartition === undefined) {
        throw new Error("invalid streamPartID string: ".concat(streamPartIdAsStr));
      }

      (0, StreamID_1.toStreamID)(streamId); // throws if not valid

      ensureValidStreamPartition(streamPartition);
      return streamPartIdAsStr;
    }
  }, {
    key: "getStreamID",
    value: function getStreamID(streamPartId) {
      return this.getStreamIDAndPartition(streamPartId)[0];
    }
  }, {
    key: "getStreamPartition",
    value: function getStreamPartition(streamPartId) {
      return this.getStreamIDAndPartition(streamPartId)[1];
    }
  }, {
    key: "getStreamIDAndPartition",
    value: function getStreamIDAndPartition(streamPartId) {
      return StreamPartIDUtils.parseRawElements(streamPartId);
    }
  }, {
    key: "parseRawElements",
    value: function parseRawElements(str) {
      var lastIdx = str.lastIndexOf(DELIMITER);

      if (lastIdx === -1 || lastIdx === str.length - 1) {
        return [str, undefined];
      }

      return [str.substring(0, lastIdx), Number(str.substring(lastIdx + 1))];
    }
  }]);

  return StreamPartIDUtils;
}();

exports.StreamPartIDUtils = StreamPartIDUtils;